import Vue from 'vue';

export default {
    capitalize(str: string) {
        return `${str.slice(0, 1).toUpperCase()}${str.slice(1).toLowerCase()}`;
    },
    getDynamicComponent(tag: string, innerText: string) {
        return Vue.component('PostSection', {
            render: (element) => {
                return element(
                    tag,
                    innerText,
                );
            },
        });
    },
    formatDate(dt: Date) {
        const leadingZero = (v: number) => v.toString().padStart(2, '0');

        const info = new Date(dt);
        return `${info.getFullYear()}.${leadingZero(info.getMonth() + 1)}.${leadingZero(info.getDate())}`;
    },
    formatTime(dt: Date) {
        const info = new Date(dt);
        const period = info.getHours() < 12 ? 'AM' : 'PM';
        const minutes = info.getMinutes().toString();
        const seconds = info.getSeconds().toString();
        return `${info.getHours() % 12}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')} ${period} EST`;
    },
    getTimeAttribute(dt: Date) {
        const info = new Date(dt);
        const minutes = info.getMinutes().toString();
        const seconds = info.getSeconds().toString();
        return `${info.getFullYear()}-${info.getMonth() + 1}-${info.getDate()}T${info.getHours()}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    },
};
